import { fechaHora } from "./constants";

const Firma = ({ rol, f, testid }) => (
  <div className="rounded-xl border border-slate-200 overflow-hidden" data-testid={testid}>
    <p className="bg-[#EEF8FA] px-3 py-1.5 text-xs font-bold text-[#1B2B4B]">{rol}</p>
    <div className="h-24 flex items-center justify-center px-3">
      {f?.imagen ? <img src={f.imagen} alt={`Firma de ${f.nombre}`} className="max-h-20 max-w-full object-contain" /> : <span className="text-xs text-slate-400">Pendiente de firma</span>}
    </div>
    <div className="px-3 pb-2.5 text-xs text-slate-600">
      <p>Fdo.: {f?.nombre || "—"}{f?.cargo ? ` · ${f.cargo}` : ""}</p>
      {f?.fecha && <p className="text-slate-400">Fecha: {fechaHora(f.fecha)}</p>}
    </div>
  </div>
);

const Tabla = ({ filas }) => (
  <div className="overflow-x-auto my-2">
    <table className="w-full text-xs sm:text-sm">
      <thead><tr className="bg-[#1B2B4B] text-white">{filas[0].map((h, i) => <th key={h} className={`px-3 py-2 font-semibold ${i === 2 ? "text-right" : "text-left"}`}>{h}</th>)}</tr></thead>
      <tbody>
        {filas.slice(1).map((f, i) => (
          <tr key={f.join("|")} className={i === filas.length - 2 ? "bg-[#EEF8FA] font-bold border-t-2 border-[#00B4CC]" : "border-b border-slate-100"}>
            {f.map((x, j) => <td key={filas[0][j]} className={`px-3 py-2 ${j === 2 ? "text-right whitespace-nowrap" : ""}`}>{x}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

// Vista del contrato tal y como saldrá en el PDF (mismo texto que genera el servidor).
export const DocumentoContrato = ({ v }) => {
  const iAnexo = v.secciones.findIndex((s) => s.titulo.startsWith("ANEXO"));
  const cuerpo = iAnexo < 0 ? v.secciones : v.secciones.slice(0, iAnexo);
  const anexo = iAnexo < 0 ? [] : v.secciones.slice(iAnexo);
  const seccion = (s, i) => (
    <section key={s.titulo || `seccion-${i}`} className="mt-5">
      {s.titulo && <h3 className="border-l-4 border-[#00B4CC] pl-2.5 text-[13px] font-bold text-[#1B2B4B] mb-2">{s.titulo}</h3>}
      {s.parrafos.map((p, j) => <p key={j} className="text-[13px] leading-relaxed text-slate-700 mb-2 text-justify">{p}</p>)}
      {s.tabla && <><Tabla filas={s.tabla} /><p className="text-[13px] leading-relaxed text-slate-700 mt-2 text-justify">{s.cierre}</p></>}
    </section>
  );
  return (
    <article className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden font-['Montserrat',sans-serif]" data-testid="documento-contrato">
      <header className="bg-[#1B2B4B] px-5 sm:px-8 py-4 flex items-center justify-between gap-3 border-b-4 border-[#00B4CC]">
        <div className="flex items-center gap-3 min-w-0">
          {v.logo && <span className="h-11 max-w-[150px] rounded-lg bg-white px-2 flex items-center justify-center shrink-0"><img src={v.logo} alt={`Logo de ${v.empresa}`} className="max-h-8 max-w-full object-contain" data-testid="documento-logo" /></span>}
          <span className="min-w-0">
            <span className="block text-white font-bold leading-tight truncate" data-testid="documento-empresa">{v.empresa}</span>
            {v.nif_empresa && <span className="block text-[10px] font-semibold tracking-wider text-[#00B4CC]">NIF/CIF {v.nif_empresa}</span>}
          </span>
        </div>
        <span className="text-xs text-white/80 shrink-0" data-testid="documento-numero">Contrato n.º {v.numero}</span>
      </header>
      <div className="px-5 sm:px-10 py-6 sm:py-8">
        <h2 className="text-lg sm:text-xl font-extrabold text-[#1B2B4B] uppercase">{v.titulo_modelo}</h2>
        <p className="text-sm text-slate-500">{v.titulo}</p>
        {cuerpo.map(seccion)}
        <div className="grid sm:grid-cols-2 gap-4 mt-6">
          <Firma rol={v.roles.emp} f={v.firma_empresa} testid="documento-firma-empresa" />
          <Firma rol={v.roles.otra} f={v.firma_cliente} testid="documento-firma-cliente" />
        </div>
        {anexo.map(seccion)}
        {v.huella && <p className="mt-6 text-[10px] text-slate-400 break-all" data-testid="documento-huella">Huella del documento (SHA-256): {v.huella}</p>}
      </div>
    </article>
  );
};
